import React from 'react'
import { Card } from 'react-bootstrap'
// import moment from 'moment'

const ReingresarCPADialogView = (props) => {
  const { cpa, presunta } = props
  return (
    <div style={{ padding: '8px' }}>
      {cpa && <Card className='shadow bg-white rounded text-left'>
        <Card.Header>
          <Card.Title style={{ fontSize: '1.4em' }}><strong>CTG: {cpa.numero}</strong></Card.Title>
        </Card.Header>
        <Card.Body style={{ fontSize: '1.2em' }}>
          <Card.Text>Fecha de Cupo: <strong>{presunta.fechaCupo}</strong> - Tipo Cupo: <strong>{presunta.tipoCupo}</strong></Card.Text>
          <Card.Text>Codigo de Cupo: <strong>{cpa.codigoCupo}</strong> Cosecha: <strong>{cpa.cosecha}</strong></Card.Text>
          <Card.Text>Cereal: <strong>{cpa.cereal}</strong> Cereal Variedad: <strong>{cpa.cerealVariedad}</strong></Card.Text>
          <Card.Text>Exportador: <strong>{cpa.exportador}</strong> Cuit: <strong>{cpa.cuitExportador}</strong></Card.Text>
          <Card.Text>Titular CPE: <strong>{cpa.titular}</strong> Cuit: <strong>{cpa.cuitTitular}</strong></Card.Text>
          {cpa.remitenteComercialProductor && <Card.Text>Rte. Com. Productor: <strong>{cpa.remitenteComercialProductor}</strong> Cuit: <strong>{cpa.cuitRemitenteComercialProductor}</strong></Card.Text>}
          {cpa.remitenteComercialVentaPrimaria && <Card.Text>Rte. Com. Vta. Primaria: <strong>{cpa.remitenteComercialVentaPrimaria}</strong> Cuit: <strong>{cpa.cuitRemitenteComercialVentaPrimaria}</strong></Card.Text>}
          {cpa.remitenteComercialVentaSecundaria && <Card.Text>Rte. Com. Vta. Secundaria: <strong>{cpa.remitenteComercialVentaSecundaria}</strong> Cuit: <strong>{cpa.cuitRemitenteComercialVentaSecundaria}</strong></Card.Text>}
          {cpa.intermediario && <Card.Text>Rte. Com. Vta. Secundaria 2: <strong>{cpa.intermediario}</strong> Cuit: <strong>{cpa.cuitIntermediario}</strong></Card.Text>}
          <Card.Text>Corredor Venta Primaria: <strong>{cpa.corredorComprador}</strong></Card.Text>
          <Card.Text>Corredor Venta Secundaria: <strong>{cpa.corredorVendedor}</strong></Card.Text>
        </Card.Body>
      </Card>}
    </div >
  )
}

export default ReingresarCPADialogView
